<div class="admin-edit-data-root" *transloco="let t">
  <div [formGroup]="adminDataFormGroup" class="admin-edit-data-form">
    <app-image-upload  
    (imgUrlChange)="saveNewImage($event)"
    [control]="getControl('picture')">
    </app-image-upload>
    <div class="admin-data">
      <span class="label-text">
        {{ adminDataLabels.setAName }}
      </span>
      <app-input id="admin-data-name-input"
                 [control]="getControl('name')"
                 required>
      </app-input>
      <span class="admin-email"> 
        {{ adminDataFormGroup.get('email')?.value }}
      </span>
    </div>
  </div>
  <span class="global-admin"> 
    {{ adminDataLabels.globalAdmin }}
  </span>
</div>
